import React from "react";
import { notify } from "@/shared/utils/notify";
import { sushiLunchProductsService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams } from "react-router-dom";

export const useCreateSushiLunchProduct = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const { rule_id } = useParams();

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        product_id: yup.string().required("Campo requerido"),
      })
    ),
  });

  const handleSubmit = onSubmit(async (data: any) => {
    if (loading) return;

    setLoading(true);
    await sushiLunchProductsService
      .create({
        product_id: +data.product_id,
        rule_sushi_lunch_id: Number(rule_id),
      })
      .then((_res: any) => {
        notify.success(`Producto añadido exitosamente`);
        setOpenModalCreate(false);
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoading(false);
      });
  });

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
